/**
 * Care Plan Service
 * Patient care plan management and tracking API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { CapacitorHttp } from '@capacitor/core';
import { HttpParameterCodec, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import Session from 'supertokens-web-js/recipe/session';
import { AuthStrategy } from '@generator-strategies/auth-strategy';
import { LanguageStrategy } from '@generator-strategies/language-strategy';
import { TenantStrategy } from '@generator-strategies/tenant-strategy';

// @ts-ignore
import { AddGoalRequestDto } from '../model/addGoalRequestDto';
// @ts-ignore
import { CarePlansControllerCreate200Response } from '../model/carePlansControllerCreate200Response';
// @ts-ignore
import { CarePlansControllerList200Response } from '../model/carePlansControllerList200Response';
// @ts-ignore
import { ChangeStatusRequestDto } from '../model/changeStatusRequestDto';
// @ts-ignore
import { CreateCarePlanRequestDto } from '../model/createCarePlanRequestDto';
// @ts-ignore
import { IntegrationsControllerRecreateWorkItemsByFilters200Response } from '../model/integrationsControllerRecreateWorkItemsByFilters200Response';
// @ts-ignore
import { LinkEncounterRequestDto } from '../model/linkEncounterRequestDto';
// @ts-ignore
import { LinkObservationRequestDto } from '../model/linkObservationRequestDto';
// @ts-ignore
import { PatchCarePlanRequestDto } from '../model/patchCarePlanRequestDto';
// @ts-ignore
import { RecreateWorkItemsByFiltersRequestDto } from '../model/recreateWorkItemsByFiltersRequestDto';
// @ts-ignore
import { RecreateWorkItemsRequestDto } from '../model/recreateWorkItemsRequestDto';
// @ts-ignore
import { UpdateCarePlanRequestDto } from '../model/updateCarePlanRequestDto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root'
})
export class CarePlansService {
  protected basePath = 'http://localhost';
  public defaultHeaders: any = {};
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    @Optional()@Inject(BASE_PATH) basePath: string|string[],
    @Optional() configuration: Configuration,
    @Optional() private readonly authStrategy: AuthStrategy,
    @Optional() private readonly languageStrategy: LanguageStrategy,
    @Optional() private readonly tenantStrategy: TenantStrategy,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (Array.isArray(basePath) && basePath.length > 0) {
        basePath = basePath[0];
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }


  /**
   * Create a care plan
   * @param createCarePlanRequestDto
   */
  public async carePlansControllerCreate(createCarePlanRequestDto: CreateCarePlanRequestDto, ): Promise<CarePlansControllerCreate200Response> {
    if (createCarePlanRequestDto === null || createCarePlanRequestDto === undefined) {
      throw new Error('Required parameter createCarePlanRequestDto was null or undefined when calling carePlansControllerCreate.');
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-care-plan/care-plans`,
        data: createCarePlanRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Delete care plan (soft delete)
   * @param planId
   */
  public async carePlansControllerDelete(planId: string, ): Promise<any> {
    if (planId === null || planId === undefined) {
      throw new Error('Required parameter planId was null or undefined when calling carePlansControllerDelete.');
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.delete({
      url: `${this.configuration.basePath}/api/forthbridge-care-plan/care-plans/${this.configuration.encodeParam({name: "planId", value: planId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Get care plan by ID
   * @param planId
   * @param expand Fields to expand in the response
   */
  public async carePlansControllerGetById(planId: string, expand?: Array<'care-plan-type' | 'work-items' | 'encounters' | 'observation-types'>, ): Promise<CarePlansControllerCreate200Response> {
    if (planId === null || planId === undefined) {
      throw new Error('Required parameter planId was null or undefined when calling carePlansControllerGetById.');
    }

    const localVarQueryParameters = new URLSearchParams();
      if (expand) {
        expand.forEach((element) => {
          localVarQueryParameters.append('expand', String(element));
        });
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const queryString = localVarQueryParameters.toString();
    const urlWithParams = queryString ? `${this.configuration.basePath}/api/forthbridge-care-plan/care-plans/${this.configuration.encodeParam({name: "planId", value: planId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}?${queryString}` : `${this.configuration.basePath}/api/forthbridge-care-plan/care-plans/${this.configuration.encodeParam({name: "planId", value: planId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
    const response = await CapacitorHttp.get({
      url: urlWithParams,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * List care plans
   * @param patientId Filter by patient ID
   * @param problemId Filter by problem ID
   * @param elementId Filter by plan type element ID
   * @param collectionId Filter by collection ID
   * @param status Filter by care plan status
   * @param limit Number of items to return
   * @param offset Number of items to skip
   * @param orderBy Field to sort by
   * @param orderDirection Sort order
   * @param expand Fields to expand in the response
   */
  public async carePlansControllerList(patientId?: string, problemId?: string, elementId?: string, collectionId?: string, status?: 'open' | 'on-hold' | 'closed', limit?: number, offset?: number, orderBy?: string, orderDirection?: 'ASC' | 'DESC', expand?: Array<'care-plan-type' | 'work-items' | 'encounters' | 'observation-types'>, ): Promise<CarePlansControllerList200Response> {

    const localVarQueryParameters = new URLSearchParams();
    if (patientId !== undefined && patientId !== null) {
      localVarQueryParameters.append('patientId', String(patientId));
    }
    if (problemId !== undefined && problemId !== null) {
      localVarQueryParameters.append('problemId', String(problemId));
    }
    if (elementId !== undefined && elementId !== null) {
      localVarQueryParameters.append('elementId', String(elementId));
    }
    if (collectionId !== undefined && collectionId !== null) {
      localVarQueryParameters.append('collectionId', String(collectionId));
    }
    if (status !== undefined && status !== null) {
      localVarQueryParameters.append('status', String(status));
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters.append('limit', String(limit));
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters.append('offset', String(offset));
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters.append('orderBy', String(orderBy));
    }
    if (orderDirection !== undefined && orderDirection !== null) {
      localVarQueryParameters.append('orderDirection', String(orderDirection));
    }
      if (expand) {
        expand.forEach((element) => {
          localVarQueryParameters.append('expand', String(element));
        });
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const queryString = localVarQueryParameters.toString();
    const urlWithParams = queryString ? `${this.configuration.basePath}/api/forthbridge-care-plan/care-plans?${queryString}` : `${this.configuration.basePath}/api/forthbridge-care-plan/care-plans`;
    const response = await CapacitorHttp.get({
      url: urlWithParams,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Patch care plan (partial update)
   * @param planId
   * @param patchCarePlanRequestDto
   */
  public async carePlansControllerPatch(planId: string, patchCarePlanRequestDto: PatchCarePlanRequestDto, ): Promise<CarePlansControllerCreate200Response> {
    if (planId === null || planId === undefined) {
      throw new Error('Required parameter planId was null or undefined when calling carePlansControllerPatch.');
    }
    if (patchCarePlanRequestDto === null || patchCarePlanRequestDto === undefined) {
      throw new Error('Required parameter patchCarePlanRequestDto was null or undefined when calling carePlansControllerPatch.');
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.patch({
      url: `${this.configuration.basePath}/api/forthbridge-care-plan/care-plans/${this.configuration.encodeParam({name: "planId", value: planId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
        data: patchCarePlanRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Update care plan (full replacement)
   * @param planId
   * @param updateCarePlanRequestDto
   */
  public async carePlansControllerUpdate(planId: string, updateCarePlanRequestDto: UpdateCarePlanRequestDto, ): Promise<CarePlansControllerCreate200Response> {
    if (planId === null || planId === undefined) {
      throw new Error('Required parameter planId was null or undefined when calling carePlansControllerUpdate.');
    }
    if (updateCarePlanRequestDto === null || updateCarePlanRequestDto === undefined) {
      throw new Error('Required parameter updateCarePlanRequestDto was null or undefined when calling carePlansControllerUpdate.');
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.put({
      url: `${this.configuration.basePath}/api/forthbridge-care-plan/care-plans/${this.configuration.encodeParam({name: "planId", value: planId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
        data: updateCarePlanRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Add goal to care plan
   * @param planId
   * @param addGoalRequestDto
   */
  public async goalsControllerAddGoal(planId: string, addGoalRequestDto: AddGoalRequestDto, ): Promise<CarePlansControllerCreate200Response> {
    if (planId === null || planId === undefined) {
      throw new Error('Required parameter planId was null or undefined when calling goalsControllerAddGoal.');
    }
    if (addGoalRequestDto === null || addGoalRequestDto === undefined) {
      throw new Error('Required parameter addGoalRequestDto was null or undefined when calling goalsControllerAddGoal.');
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-care-plan/care-plans/${this.configuration.encodeParam({name: "planId", value: planId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/goals`,
        data: addGoalRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Link encounter to care plan
   * @param planId
   * @param linkEncounterRequestDto
   */
  public async integrationsControllerLinkEncounter(planId: string, linkEncounterRequestDto: LinkEncounterRequestDto, ): Promise<any> {
    if (planId === null || planId === undefined) {
      throw new Error('Required parameter planId was null or undefined when calling integrationsControllerLinkEncounter.');
    }
    if (linkEncounterRequestDto === null || linkEncounterRequestDto === undefined) {
      throw new Error('Required parameter linkEncounterRequestDto was null or undefined when calling integrationsControllerLinkEncounter.');
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-care-plan/care-plans/${this.configuration.encodeParam({name: "planId", value: planId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/encounters`,
        data: linkEncounterRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Link observation to care plan goal
   * @param planId
   * @param linkObservationRequestDto
   */
  public async integrationsControllerLinkObservation(planId: string, linkObservationRequestDto: LinkObservationRequestDto, ): Promise<any> {
    if (planId === null || planId === undefined) {
      throw new Error('Required parameter planId was null or undefined when calling integrationsControllerLinkObservation.');
    }
    if (linkObservationRequestDto === null || linkObservationRequestDto === undefined) {
      throw new Error('Required parameter linkObservationRequestDto was null or undefined when calling integrationsControllerLinkObservation.');
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-care-plan/care-plans/${this.configuration.encodeParam({name: "planId", value: planId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/observations`,
        data: linkObservationRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Recreate recommended work items for care plan
   * @param planId
   * @param recreateWorkItemsRequestDto
   */
  public async integrationsControllerRecreateWorkItems(planId: string, recreateWorkItemsRequestDto: RecreateWorkItemsRequestDto, ): Promise<CarePlansControllerCreate200Response> {
    if (planId === null || planId === undefined) {
      throw new Error('Required parameter planId was null or undefined when calling integrationsControllerRecreateWorkItems.');
    }
    if (recreateWorkItemsRequestDto === null || recreateWorkItemsRequestDto === undefined) {
      throw new Error('Required parameter recreateWorkItemsRequestDto was null or undefined when calling integrationsControllerRecreateWorkItems.');
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-care-plan/care-plans/${this.configuration.encodeParam({name: "planId", value: planId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/work-items/recreate`,
        data: recreateWorkItemsRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Recreate work items for care plans matching filters
   * @param recreateWorkItemsByFiltersRequestDto
   */
  public async integrationsControllerRecreateWorkItemsByFilters(recreateWorkItemsByFiltersRequestDto: RecreateWorkItemsByFiltersRequestDto, ): Promise<IntegrationsControllerRecreateWorkItemsByFilters200Response> {
    if (recreateWorkItemsByFiltersRequestDto === null || recreateWorkItemsByFiltersRequestDto === undefined) {
      throw new Error('Required parameter recreateWorkItemsByFiltersRequestDto was null or undefined when calling integrationsControllerRecreateWorkItemsByFilters.');
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-care-plan/care-plans/work-items/recreate`,
        data: recreateWorkItemsByFiltersRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Change care plan status
   * @param planId
   * @param changeStatusRequestDto
   */
  public async statusControllerChangeStatus(planId: string, changeStatusRequestDto: ChangeStatusRequestDto, ): Promise<CarePlansControllerCreate200Response> {
    if (planId === null || planId === undefined) {
      throw new Error('Required parameter planId was null or undefined when calling statusControllerChangeStatus.');
    }
    if (changeStatusRequestDto === null || changeStatusRequestDto === undefined) {
      throw new Error('Required parameter changeStatusRequestDto was null or undefined when calling statusControllerChangeStatus.');
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-care-plan/care-plans/${this.configuration.encodeParam({name: "planId", value: planId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/status`,
        data: changeStatusRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
}
